// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"081875d2","2744":"7c9d415b"}[chunkId] + ".chunk.css";
};